import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EnvironmentService} from '@core/environment/environment.service';
import {Observable} from 'rxjs';
import {LanguageEnum} from '@core/enums/language.enum';
import {FileModel} from '@core/modules/rest/file/file.model';
import {FileResponseModel} from '@core/modules/rest/file/file-response.model';

@Injectable()
export class FileRestService {

    constructor(private httpClient: HttpClient, private environmentService: EnvironmentService) {
    }

    private controllerUrl = this.environmentService.serverApiUrl + '/secured/file';

    getPopupMultimediaImage(imageIdentifier: string, indicationId: string): Observable<any> {
        return this.httpClient.get(this.controllerUrl + '/multimedia/' + imageIdentifier + '/' + indicationId, {responseType: 'arraybuffer'});
    }

    getPopupMultimediaImageDescription(imageIdentifier: string, indicationId: string, language: LanguageEnum): Observable<string> {
        return this.httpClient.get(this.controllerUrl.concat('/description/').concat(imageIdentifier).concat('/').concat(indicationId).concat('/').concat(language), {responseType: 'text'});
    }

    getAllOrganizationImagesPagination(offset: number): Observable<FileModel[]> {
        return this.httpClient.get<FileModel[]>(this.controllerUrl + `/images/${offset}`);
    }

    getSingleResource(path: string): Observable<any> {
        const encodedPath = btoa(unescape(encodeURIComponent(path)));
        return this.httpClient.get(this.controllerUrl + '/multimedia/' + encodedPath, {responseType: 'arraybuffer'});
    }

    getSingleResourceById(id: string): Observable<any> {
        return this.httpClient.get(this.controllerUrl + `/${id}/multimedia/`, {responseType: 'arraybuffer'});
    }

    upload(file: File): Observable<FileResponseModel> {
        const formData: FormData = new FormData();
        formData.append('file', file);
        const url: string = this.controllerUrl + '/multimedia/upload';
        return this.httpClient.post<FileResponseModel>(url, formData);
    }

    deleteMediaById(fileIds: string[]): Observable<string[]> {
        return this.httpClient.post<string[]>(this.controllerUrl + '/multimedia/delete', fileIds);
    }
}

